import dayjs from "dayjs";

/**
 * The month the "Latest Month" charts on an overview page actually cover.
 *
 * The server does not send this. Every `/overview` endpoint derives its own
 * window from the server clock — `dayjs().subtract(n, "M")` — and returns only
 * the rows, so the label has to re-derive the same offset here. Each caller
 * passes the offset its own bar chart uses; keep the two in step if the server
 * window ever moves.
 *
 * Deriving it client-side means a browser whose clock/timezone has already
 * rolled into the next month can name a month the server has not moved to yet.
 * Only reachable in the hours either side of a month boundary.
 */
export const latestMonth = (monthsAgo: number): string =>
  dayjs().subtract(monthsAgo, "M").format("MMMM YYYY");
